import { Button, Result, Typography } from "antd";

/**
 * Trạng thái không-quyền (403 — BA-06 §5, BR-SEC-02): thông báo chung,
 * KHÔNG tiết lộ sự tồn tại của bản ghi; component không nhận bất kỳ prop
 * định danh/tên hồ sơ nào (anti-leak mặc định theo chữ ký props).
 */
export function ForbiddenState({ description, onBack }: {
  readonly description?: string;
  readonly onBack?: () => void;
}) {
  return (
    <Result
      status="403"
      title={
        <Typography.Title level={2} style={{ marginBlockEnd: "var(--ncc-spacing-xs)" }}>
          Không có quyền truy cập
        </Typography.Title>
      }
      subTitle={
        description ??
        "Bạn không được cấp quyền xem nội dung này. Liên hệ quản trị viên nếu cho rằng đây là thiếu sót."
      }
      extra={
        onBack ? (
          <Button type="primary" onClick={onBack}>
            Quay lại
          </Button>
        ) : null
      }
    />
  );
}
